import { initializeApp } from 'firebase/app';
import { getDatabase, ref, onValue, update, get } from 'firebase/database';

const firebaseConfig = {
  apiKey: 'AIzaSyDWP4y79teOK4i8jaO_hudhnE0amNIuJcI',
  authDomain: 'barber-shop-c51fc.firebaseapp.com',
  databaseURL: 'https://barber-shop-c51fc-default-rtdb.europe-west1.firebasedatabase.app',
  projectId: 'barber-shop-c51fc',
  storageBucket: 'barber-shop-c51fc.firebasestorage.app',
  messagingSenderId: '870769474917',
  appId: '1:870769474917:android:36440293c9b7c58c6d358c'
};

const app = initializeApp(firebaseConfig);
const database = getDatabase(app);

class FirebaseService {
  constructor() {
    this.shopRef = ref(database, 'shop');
  }

  // Listen to shop data changes
  onShopDataChange(callback) {
    return onValue(this.shopRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        callback(data);
      }
    });
  }

  // Increment analytics for status views using public analytics path
  async incrementStatusView(status) {
    try {
      // Read current analytics
      const analyticsRef = ref(database, 'public_analytics');
      const snapshot = await get(analyticsRef);
      
      let analytics = {
        green_views: 0,
        yellow_views: 0,
        orange_views: 0,
        closed_views: 0
      };
      
      // If analytics exist, use current values
      if (snapshot.exists()) {
        analytics = snapshot.val();
      }
      
      // Increment the appropriate counter
      const statusKey = `${status}_views`;
      if (analytics[statusKey] !== undefined) {
        analytics[statusKey]++;
      }
      
      // Update analytics (set all fields to ensure validation passes)
      await update(analyticsRef, {
        green_views: analytics.green_views || 0,
        yellow_views: analytics.yellow_views || 0,
        orange_views: analytics.orange_views || 0,
        closed_views: analytics.closed_views || 0
      });
    } catch (error) {
      console.error('Error incrementing analytics:', error);
    }
  }

  // Reset all analytics counters to zero
  async resetAnalytics() {
    try {
      await update(ref(database, 'shop/analytics'), {
        green_views: 0,
        yellow_views: 0,
        orange_views: 0,
        closed_views: 0
      });
      console.log('Analytics reset successfully');
      return true;
    } catch (error) {
      console.error('Error resetting analytics:', error);
      return false;
    }
  }
}

const firebaseService = new FirebaseService();
export default firebaseService;